const getBackendURL = () => {
  switch (process.env.REACT_APP_CIRCLE_BRANCH) {
    case 'develop':
      return process.env.REACT_APP_PILOT_API_URL
    case 'staging':
      return process.env.REACT_APP_STAGING_API_URL
    default:
      return process.env.REACT_APP_API_URL
  }
}

export default getBackendURL
